import { WorkAreaCreateDialog } from '@/components/work-areas/WorkAreaCreateDialog';
import { WorkAreaDetail } from '@/components/work-areas/WorkAreaDetail';
import { WorkAreaList } from '@/components/work-areas/WorkAreaList';

export function WorkAreasPage(): React.ReactElement {
  return (
    <div className="relative flex flex-1 flex-col overflow-auto lg:overflow-hidden">
      <span aria-hidden className="fd-glow-sky pointer-events-none absolute inset-0 opacity-50" />
      <div className="relative flex items-start justify-between px-6 pb-3 pt-5">
        <div>
          <h1 className="text-lg font-semibold tracking-tight text-text-primary">Work Areas</h1>
          <p className="mt-1 text-xs text-text-tertiary">
            Group codebases, default env vars, and conversation defaults
          </p>
        </div>
        <WorkAreaCreateDialog />
      </div>
      <div className="relative grid min-h-0 flex-1 grid-cols-1 gap-4 overflow-visible px-6 pb-6 pt-1 lg:grid-cols-[minmax(0,1fr)_minmax(28rem,0.9fr)] lg:overflow-hidden">
        <div className="min-h-0 overflow-visible lg:overflow-auto">
          <WorkAreaList />
        </div>
        <div className="min-h-[24rem] overflow-visible lg:min-h-0 lg:overflow-hidden">
          <WorkAreaDetail />
        </div>
      </div>
    </div>
  );
}
